/* eslint-disable vue/no-unused-vars */
<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Usuarios</strong>
      </div>
    </div>
    <div class="card-body">
      <a-table
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
        :columns="columns"
        rowKey="id"
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <!--
        <a
          slot="id"
          slot-scope="text"
          href="javascript: void(0);"
          class="utils__link--underlined"
          >#{{ text }}</a
        >
        <span slot="action">
          <a-button icon="edit" class="mr-1" size="small">View</a-button>
          <a-button icon="cross" size="small">Remove</a-button>
        </span>
        -->
        <template slot="title" slot-scope="">
          <a-button class="editable-add-btn" @click="handleAdd"
            >+ Nuevo</a-button
          >
        </template>
        <template
          v-for="col in [
            'id',
            'name',
            'email',
            'password',
            'role',
            'ERPCode',
            'locationERPCode',
            'businessUnit'
          ]"
          :slot="col"
          slot-scope="text, record"
        >
          <div :key="col">
            <a-input
              v-if="
                (record.editable &&
                  col != 'password' &&
                  col != 'role' &&
                  col != 'businessUnit') ||
                  (record.add && col != 'role' && col != 'businessUnit')
              "
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.id, col)"
            />
            <a-select
              v-else-if="record.editable && col == 'role'"
              labelInValue
              :defaultValue="{
                key: record.usersAccounts ? record.usersAccounts[0].role.id : 2
              }"
              @change="value => handleChange(value, record.id, col)"
              style="width: 120px"
            >
              <a-select-option
                v-for="role in roles"
                :key="role.id"
                :value="role.id"
                >{{ role.name }}</a-select-option
              >
            </a-select>
            <a-select
              v-else-if="record.editable && col == 'businessUnit'"
              labelInValue
              :defaultValue="{
                key: record.sellerBusinessUnit
                  ? record.sellerBusinessUnit.id
                  : null
              }"
              @change="value => handleChange(value, record.id, col)"
              style="width: 120px"
            >
              <a-select-option
                v-for="bu in businessUnits"
                :value="bu.id"
                :key="bu.id"
                >{{ bu.name }}</a-select-option
              >
            </a-select>
            <template v-else>{{ text }}</template>
          </div>
        </template>

        <span slot="operation" slot-scope="text, record">
          <span v-if="record.add">
            <a-button
              icon="plus"
              class="mr-1"
              size="small"
              @click="() => addRecord(record.id)"
              >Agregar
            </a-button>
            <a-popconfirm
              title="¿Seguro desea cancelar?"
              okText="Si"
              cancelText="No"
              @confirm="() => fetchTableData()"
            >
              <a-button icon="cross" class="mr-1" size="small"
                >Cancelar
              </a-button>
            </a-popconfirm>
          </span>
          <span v-else>
            <span v-if="record.editable">
              <a-button
                icon="edit"
                class="mr-1"
                size="small"
                @click="() => saveRecord(record.id)"
                >Guardar
              </a-button>
              <a-popconfirm
                title="¿Seguro desea cancelar?"
                okText="Si"
                cancelText="No"
                @confirm="() => cancelEdit(record.id)"
              >
                <a-button icon="cross" class="mr-1" size="small"
                  >Cancelar
                </a-button>
              </a-popconfirm>
            </span>
            <span v-else>
              <a-button
                icon="edit"
                class="mr-1"
                size="small"
                @click="() => editRow(record.id)"
                >Editar</a-button
              >
              <a-popconfirm
                v-if="tableData.length"
                title="¿Seguro desea eliminar el registro?"
                @confirm="() => deleteRecord(record.id)"
              >
                <a-button icon="cross" class="mr-1" size="small"
                  >Borrar</a-button
                >
              </a-popconfirm>
            </span>
          </span>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id",
    sorter: true
  },
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
    sorter: true,
    scopedSlots: { customRender: "name" }
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sorter: true,
    scopedSlots: { customRender: "email" }
  },
  {
    title: "Contraseña",
    dataIndex: "password",
    key: "password",
    sorter: true,
    scopedSlots: { customRender: "password" }
  },
  {
    title: "Rol",
    dataIndex: "usersAccounts[0].role.name",
    key: "role",
    sorter: true,
    scopedSlots: { customRender: "role" }
  },
  {
    title: "Código ERP",
    dataIndex: "ERPCode",
    key: "ERPCode",
    sorter: true,
    scopedSlots: { customRender: "ERPCode" }
  },
  {
    title: "Jurisdicción",
    dataIndex: "locationERPCode",
    key: "locationERPCode",
    sorter: true,
    scopedSlots: { customRender: "locationERPCode" }
  },
  {
    title: "Unidad de Negocios",
    dataIndex: "sellerBusinessUnit.name",
    key: "businessUnit",
    sorter: true,
    scopedSlots: { customRender: "businessUnit" }
  },
  {
    title: "Acciones",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
];
const tableData = [];
export default {
  data() {
    this.cacheData = tableData.map(item => ({ ...item }));
    return {
      tableData: [],
      cachedData: {},
      pagination: {
        position: "bottom"
      },
      loading: false,
      columns,
      roles: [],
      businessUnits: []
    };
  },
  methods: {
    ...mapActions({
      loadUsers: "users/load",
      saveUser: "users/save",
      addUser: "users/add",
      deleteUser: "users/delete",
      loadRoles: "users/loadRoles",
      loadBusinessUnits: "users/loadBusinessUnits"
    }),
    async handleAdd() {
      if (this.roles.length === 0) {
        this.roles = await this.loadRoles();
      }
      if (this.businessUnits.length === 0) {
        this.businessUnits = await this.loadBusinessUnits();
      }

      //chekea si ya hay una fila para agregar nuevo registro
      if (!this.tableData.filter(item => "+" === item.id)[0]) {
        const { count, tableData } = this;
        const newData = {
          id: "+",
          name: "",
          email: "",
          password: "",
          role: { id: 3 }
        };
        this.tableData = [newData, ...tableData];
        //this.count = count + 1;
        const target = this.tableData.filter(item => "+" === item.id)[0];
        if (target) {
          target.editable = true;
          target.add = true;
          //this.tableData = newData;
          //this.cachedRow = Object.assign({}, target);
        }
      }
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      let orderAsc = true;
      console.log(sorter);
      if (sorter.order == "descend") orderAsc = false;
      this.fetchTableData({
        pageSize: pagination.pageSize,
        page: pagination.current,
        orderBy: sorter.field,
        orderAsc: orderAsc
      });
    },
    async fetchTableData(params = {}) {
      try {
        this.loading = true;
        const result = await this.loadUsers(params);
        const pagination = {
          ...store.state.users.pagination
        };
        // Read total count from server
        pagination.total = pagination.totalResults;
        this.loading = false;
        const newData = store.state.users.results;
        this.tableData = newData;
        this.pagination = pagination;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    handleChange(value, key, column) {
      console.log({ value, key, column });
      const newData = [...this.tableData];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        if (column == "role")
          target.usersAccounts[0].role = { id: value.key, name: value.label };
        else if (column == "businessUnit")
          target["sellerBusinessUnit"] = { id: value.key, name: value.label };
        else target[column] = value;
        this.tableData = newData;
      }
    },
    async editRow(key) {
      if (this.roles.length == 0) {
        this.roles = await this.loadRoles();
      }
      if (this.businessUnits.length === 0) {
        this.businessUnits = await this.loadBusinessUnits();
      }
      const newData = [...this.tableData];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.tableData = newData;
        this.cachedRow = Object.assign({}, target);
      }
    },
    cancelEdit(key) {
      const newData = [...this.tableData];
      let target = newData.filter(item => key === item.id)[0];
      if (target) {
        Object.assign(target, this.cachedRow);
        delete target.editable;
        delete target.add;
        this.tableData = newData;
      }
    },
    async addRecord() {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => "+" === item.id)[0];
        if (target) {
          console.log("params:", params);
          this.loading = true;
          const params = {
            name: target.name,
            email: target.email,
            password: target.password,
            roleId: target.role.id,
            ERPCode: target.ERPCode,
            locationERPCode: target.locationERPCode,
            businessUnitId: target.sellerBusinessUnit
              ? target.sellerBusinessUnit.id
              : null
          };
          const result = await this.addUser(params);
          delete target.editable;
          delete target.add;
          const result2 = await this.fetchTableData();
        }
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$notification["warning"]({
          message: `Error ${error.response.status}`,
          description: error.message
        });
      }
    },
    async saveRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          //console.log("params:", params);
          this.loading = true;
          const params = {
            id: target.id,
            name: target.name,
            email: target.email,
            password: target.password,
            roleId: target.usersAccounts[0].role.id,
            ERPCode: target.ERPCode,
            locationERPCode: target.locationERPCode,
            businessUnitId: target.sellerBusinessUnit
              ? target.sellerBusinessUnit.id
              : null
          };
          const result = await this.saveUser(params);
          this.tableData = newData;
          delete target.editable;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        let description;
        if (error && error.message) description = error.message;
        else description = "Hubo un error al guardar el registro.";

        this.$notification["warning"]({
          message: "Error",
          description
        });
      }
    },
    async deleteRecord(key) {
      try {
        const newData = [...this.tableData];
        const target = newData.filter(item => key === item.id)[0];
        if (target) {
          this.loading = true;
          const result = await this.deleteUser(key);
          this.tableData = newData.filter(item => item.id !== key);
          this.loading = false;
        }
      } catch (error) {
        //this.$nprogress.done();
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    }
  },
  computed: {},
  mounted() {
    this.fetchTableData();
  }
};
</script>

<style lang="css">
.card-body {
  padding-top: 0;
}
</style>

<style lang="scss" module scoped>
@import "./style.module.scss";
.editable-row-operations a {
  margin-right: 8px;
}
</style>
